import React, { useEffect } from 'react';

import AppRouter from 'Router';
import { startVisitorLiveChat } from 'libs/Intercom';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'antd/dist/antd.css';

import './App.scss';
// import LaunchingSoonModal from "shared/LaunchingSoonModal";

function App() {
  useEffect(() => {
    startVisitorLiveChat();
  }, []);

  return (
    <>
      {/* <LaunchingSoonModal /> */}
      <AppRouter />
    </>
  );
}

export default App;
